<template>
    <div style="padding: 10px" v-if="taskInfo && taskInfo.message_list[0].nMsgType !==2013">
        <div style="text-align: center; padding: 10px 0px; font-size: 14px; color: #888888">{{getTime()}}</div>
        <div style="display: flex">
            <div style="margin-top: 5px">
                <Wp_image url="/images/wanpinjingxuan_logo_01.png" width="50px" radius="5px"></Wp_image>
            </div>
            <div>
                <div style="margin-left: 18px; font-size: 13px">
                    万品京选
                    <span v-if="!$common.isClient_whole()">-先转链再推广</span>
                </div>
                <div style="display: flex; margin-top: 3px">
                    <div style="margin-left: 5px; margin-top: 15px">
                        <van-icon name="play" size="20" color="#FFFFFF" style="transform: rotate(180deg);"/>
                    </div>

                    <div style="padding: 10px; background-color: white; border-radius: 5px;  margin-left: -8px">
                        <div @click="showImage(taskInfo.message_list[0].msgContent)">
                            <Wp_image :url="taskInfo.message_list[0].msgContent" ></Wp_image>
                        </div>

                        <div v-for="(item, index) in content_list" :key="index" style="font-size: 15px">
                            <div v-html="item" @click="clickContentItem(item)"></div>
                        </div>
                        <div v-if="!$common.isClient_whole()" style="margin-top: 5px; color: #EE0A24; font-size: 15px">复制文案或点击链接购买会自动转链，若单独复制链接，请自行转链</div>
                        <div style="text-align: right">
                            <van-button type="info" round size="small" style="width: 80px" @click="clickToShowContentPop">复制文案</van-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="show_pop" :style="{width: $common.screenWidth - 60 + 'px'}" round closeable close-icon="close">
            <div style="padding: 10px; border-radius: 10px">
                <div style="text-align: center; font-size: 17px; padding: 5px">新文案已生成</div>
                <van-field v-model="copy_content"
                           type="textarea"
                           :autosize="{maxHeight: $common.screenHeight - 200, minHeight: 100}"
                           style="border: 1px solid #dddddd; border-radius: 4px; height: 80%"
                >

                </van-field>
                <div style="padding: 10px; text-align: center">
                    <van-button type="info" size="small" round style="width: 100px"
                                v-clipboard:copy="copy_content.replace(new RegExp('<br/>','g'), '\n')"
                                v-clipboard:success="onCopySuccess"
                                v-clipboard:error="onError"

                    >复制文案</van-button>
                </div>

            </div>
        </van-popup>
    </div>
</template>

<script>
    import Wp_image from "./Wp_image";
    import {Toast, ImagePreview} from "vant";

    export default {
        name: "Wp_message_card_like_weixin",
        components: {Wp_image},
        props: {
            taskInfo: {type: Object, default: null},
            channelName: {type: String, default: ''},
        },

        data() {
            return {
                task_content: '',

                content_list: [],

                show_pop: false,

                copy_content: '',

                toastLoading: '',
            }
        },

        created() {
            this.getContent();
        },

        methods: {
            /**
             * 显示复制文案弹窗
             */
            clickToShowContentPop(){
                this.toastLoading = Toast.loading({
                    message: '文案生成...'
                });
                let _old_content = this.taskInfo.message_list[1].msgContent;
                this.getChangeLink(_old_content, '', new_content=>{
                    this.copy_content = new_content;
                    this.show_pop = true;
                });
            },

            onCopySuccess(){
                Toast.success({
                    message: '复制成功'
                });
            },

            onError(){
                Toast.fail({
                    message: '复制失败'
                });
            },

            showImage(image){
                ImagePreview({
                    images:[image],
                    closeable: true
                })
            },

            getTime() {
                if (this.taskInfo) {
                    let send_day = this.taskInfo.send_day;
                    let send_time = this.taskInfo.send_time;
                    let send_day_date = this.$common.stringToDate(send_day)

                    let send_day_format = this.$common.dateFmt('yyyy年MM月dd日', send_day_date);
                    return send_day_format + ' ' + send_time;
                }
            },


            getContent() {
                if (this.taskInfo && this.taskInfo.message_list[0].nMsgType !==2013) {
                    let title = this.taskInfo.message_list[1].msgContent;
                    let array = title.split('\n');

                    for (let i = 0; i < array.length; i++) {
                        // let item = array[i];
                        let item = this.reMakeString(array[i]);

                        this.content_list.push(item);
                    }
                }
            },

            reMakeString(str) {
                if (str.indexOf('https') !== -1) {
                    let str1 = str.substring(str.indexOf('https'));
                    let url = str1.substring(0, 23);

                    //<a @click="jumpTo('https://u.jd.com/5RRHcs')">https://u.jd.com/5RRHcs</a>
                    // let a_label = `<a>${url}</a>`;
                    let a_label = "<a>"+url+"</a>";

                    str = str.replace(url, a_label);
                }
                str = str.replace(' ', '&nbsp;')
                return str;
            },

            clickContentItem(item) {
                if (item.indexOf('https') !== -1) {
                    let str1 = item.substring(item.indexOf('https'));
                    let url = str1.substring(0, 23);

                    this.getChangeLink(url, 'yes', link=>{
                        window.location.href = link;
                    });
                }
            },

            /**
             * 转链
             */
            getChangeLink(_content, _hard, fn) {
                let params = {
                    content: _content,
                    pid: this.$common.getUsername(),
                    hard: _hard
                };

                this.$getChangeLink(params, response => {
                    if(this.toastLoading){
                        this.toastLoading.clear();
                    }
                    if (response) {
                        if (response.code === 200) {
                            if (response.content) {
                                if(response.content.indexOf('http') !== -1){
                                    if (fn) {
                                        fn(response.content);
                                    }
                                }else{
                                    Toast('优惠券无效');
                                }
                            }
                        }else if (response.code === 0) {
                            Toast('转链服务器暂无响应');
                        } else if (response.code >= 500) {
                            Toast(response.message);
                        } else if (response.toString().indexOf('Error') != -1) {
                            if (response.toString().indexOf('timeout') != -1) {
                                Toast('转链超时，请重试');
                            } else {
                                Toast('转链错误，请重试');
                            }
                        }else{
                            Toast('转链失败，请重试');
                        }
                    }else{
                        Toast('转链失败，请重试');
                    }
                })
            },


            /**
             * 某个字符串strpram在一个字符串str中第index次出现的位置
             * @param str
             * @param strpram
             * @param index
             * @returns {number}
             */
            getIndex(str, strpram, index) {
                var strValue = str;
                var strValue1 = '';
                var value = 0;
                for (var i = 0; i < index; i++) {
                    strValue1 = strValue.substring(0, strValue.indexOf(strpram));
                    strValue = strValue.substring(strValue1.length + 1);
                    value += (strValue1.length + 1);
                }
                return value;
            }
        }
    }
</script>

<style scoped>

</style>